import { createSlice } from '@reduxjs/toolkit';
import { getEventTypesVisibility } from './actions';

export const INITIAL_STATE = {
  activeOrganizations: [],
  default: 'show'
};

const slice = createSlice({
  name: 'event-types',
  initialState: INITIAL_STATE,
  extraReducers: builder => {
    builder
      .addCase(getEventTypesVisibility.pending, state => {
        state.activeOrganizations = [];
        state.default = 'show';

        return state;
      })

      .addCase(getEventTypesVisibility.fulfilled, (state, { payload }) => {
        state.activeOrganizations = payload.organizations;
        state.default = payload.default;

        return state;
      })

      .addCase(getEventTypesVisibility.rejected, state => {
        return state;
      });
  }
});

export default slice.reducer;
